/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_td_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is a text diff?`)
};

const es_td_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué es una comparación de textos?`)
};

const de_td_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist ein Text-Diff?`)
};

const nl_td_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is een tekstdiff?`)
};

const fr_td_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qu'est-ce qu'une comparaison textuelle ?`)
};

const it_td_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Che cos'è una differenza di testo?`)
};

const pt_br2_td_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que é uma diferença de texto?`)
};

const pt_td_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que é uma comparação de texto?`)
};

const ja_td_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキスト差分とは何ですか？`)
};

const zh_td_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`什么是文本比较（text diff）？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const td_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.td_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("td_faq4_q", locale)
	if (locale === "en") return en_td_faq4_q(inputs)
	if (locale === "es") return es_td_faq4_q(inputs)
	if (locale === "de") return de_td_faq4_q(inputs)
	if (locale === "nl") return nl_td_faq4_q(inputs)
	if (locale === "fr") return fr_td_faq4_q(inputs)
	if (locale === "it") return it_td_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_td_faq4_q(inputs)
	if (locale === "pt") return pt_td_faq4_q(inputs)
	if (locale === "ja") return ja_td_faq4_q(inputs)
	return zh_td_faq4_q(inputs)
};